/// <amd-module name="CodeCoverage/Common/RunViewArtifact" />
import { Build, BuildStatus } from "Build/Client/Contracts/Build";

export interface IRunViewArtifact {
    buildId: number;
    projectId: string;
    buildStatus: BuildStatus;
}

export class RunViewArtifact implements IRunViewArtifact {
    public readonly buildId: number;
    public readonly projectId: string;
    public readonly buildStatus: BuildStatus;

    public constructor(buildId: number, projectId: string, buildStatus: BuildStatus) {
        this.buildId = buildId;
        this.projectId = projectId;
        this.buildStatus = buildStatus;
    }

    public static GetArtifactDataFromBuild(build: Build): RunViewArtifact {
        return new RunViewArtifact(build.id, build.project.id, build.status);
    }
}
